import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API, BACKEND_URL } from '@/lib/config';

const DEFAULT_BRANDING = {
  system_name: 'Tecnoservice Brasil',
  logo_url: null
};

const BrandingContext = createContext({
  branding: DEFAULT_BRANDING,
  loading: true,
  refreshBranding: async () => {},
  getLogoUrl: () => null
});

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const [loading, setLoading] = useState(true);

  const refreshBranding = async () => {
    try {
      const response = await axios.get(`${API}/public/branding`);
      setBranding({
        system_name: response.data?.system_name || DEFAULT_BRANDING.system_name,
        logo_url: response.data?.logo_url || null
      });
    } catch (error) {
      setBranding(DEFAULT_BRANDING);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshBranding();
  }, []);

  useEffect(() => {
    document.title = branding.system_name || DEFAULT_BRANDING.system_name;
  }, [branding]);

  const getLogoUrl = () => {
    if (!branding.logo_url) {
      return null;
    }
    if (branding.logo_url.startsWith('http')) {
      return branding.logo_url;
    }
    return `${BACKEND_URL}${branding.logo_url}`;
  };

  return (
    <BrandingContext.Provider value={{ branding, loading, refreshBranding, getLogoUrl }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
